'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.orderBuffers = orderBuffers;
exports.getNextBuffer = getNextBuffer;
exports.getPreviousBuffer = getPreviousBuffer;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function orderBuffers(buffers) {
    var list = buffers.map(function (b) {
        return b;
    });

    list = _lodash2.default.filter(list, function (buffer) {
        return !buffer.isServer();
    });
    list = list.sort(function (a, b) {
        var order = 0;
        if (a.isChannel() && b.isQuery()) {
            order = -1;
        } else if (a.isQuery() && b.isChannel()) {
            order = 1;
        } else {
            order = a.name.localeCompare(b.name);
        }

        return order;
    });

    return list;
}

function getNextBuffer() {
    return getBufferFromDirection(1);
}

function getPreviousBuffer() {
    return getBufferFromDirection(-1);
}

function getBufferFromDirection(direction) {
    var network = _state2.default.getActiveNetwork();
    var buffer = _state2.default.getActiveBuffer();

    if (!network || !buffer) {
        return null;
    }

    var ordered = orderBuffers(network.buffers);
    var index = _lodash2.default.findIndex(ordered, ['name', buffer.name]) + direction;

    if (index >= ordered.length || index < 0) {
        network = getNetworkFromDirection(direction);
        ordered = orderBuffers(network.buffers);
        buffer = direction === 1 ? ordered[0] : ordered[ordered.length - 1];
    } else {
        buffer = ordered[index];
    }
    return buffer;
}

function getNetworkFromDirection(direction) {
    var network = _state2.default.getActiveNetwork();
    for (var i = 0; i < _state2.default.networks.length; i++) {
        var index = _lodash2.default.findIndex(_state2.default.networks, ['id', network.id]) + direction;

        if (index >= _state2.default.networks.length && _state2.default.networks.length >= 0) {
            network = _state2.default.networks[0];
        } else if (index < 0) {
            network = _state2.default.networks[_state2.default.networks.length - 1];
        } else {
            network = _state2.default.networks[index];
        }
        if (network.buffers.length > 1) {
            return network;
        }
    }
    return network;
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["bufferTools"]
window._kiwi_exports.libs.bufferTools = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/bufferTools.js
// module id = 7DgK
// module chunks = 1